"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchColumnDecoder = void 0;
const tslib_1 = require("tslib");
const clock_1 = require("../../clock");
const operations = tslib_1.__importStar(require("../../operations"));
const Patch_1 = require("../../Patch");
const Batch_1 = require("../Batch");
const util_1 = require("../util");
class BatchColumnDecoder {
    constructor(
    // ---------------------------------------------------- Header - page stats
    minSeq, maxSeq, 
    // ---------------------------------------------------------------- Columns
    sidTable, uint, s_old, s_new, t_obj, t_id, t_val, data, meta) {
        this.minSeq = minSeq;
        this.maxSeq = maxSeq;
        this.sidTable = sidTable;
        this.uint = uint;
        this.s_old = s_old;
        this.s_new = s_new;
        this.t_obj = t_obj;
        this.t_id = t_id;
        this.t_val = t_val;
        this.data = data;
        this.meta = meta;
        this.uintIdx = 0;
        this.s_oldIdx = 0;
        this.s_newIdx = 0;
        this.t_objIdx = 0;
        this.t_idIdx = 0;
        this.t_valIdx = 0;
        this.dataIdx = 0;
        this.metaIdx = 0;
    }
    decode() {
        this.s_old = (0, util_1.rld)((0, util_1.zd)(this.s_old));
        this.s_new = (0, util_1.rld)((0, util_1.zd)(this.s_new));
        this.t_obj = (0, util_1.dd)((0, util_1.zd)((0, util_1.rld)((0, util_1.zd)(this.t_obj))));
        this.t_id = (0, util_1.dd)((0, util_1.zd)((0, util_1.rld)((0, util_1.zd)(this.t_id))));
        this.t_val = (0, util_1.dd)((0, util_1.zd)((0, util_1.rld)((0, util_1.zd)(this.t_val))));
        this.meta = (0, util_1.drld)(this.meta);
        const batchMeta = this.meta[this.metaIdx++];
        const patchCount = this.uint[this.uintIdx++];
        const patches = [];
        for (let i = 0; i < patchCount; i++)
            patches.push(this.decodeGroup());
        const batch = new Batch_1.Batch(patches);
        if (batchMeta != null)
            batch.meta = batchMeta;
        return batch;
    }
    decodeGroup() {
        const opCount = this.uint[this.uintIdx++];
        const meta = this.meta[this.metaIdx++];
        const ops = [];
        for (let i = 0; i < opCount; i++)
            ops.push(this.decodeOp());
        return new Patch_1.Patch(ops, meta !== null ? meta : undefined);
    }
    decodeOp() {
        const id = this.readId();
        const uint = this.uint;
        const opRaw = uint[this.uintIdx++];
        const base = opRaw & ~0b111;
        const extra = opRaw & 0b111;
        switch (base) {
            case 0 /* JsonCrdtPatchOpcodeOverlay.new_con */: {
                if (extra === 1)
                    return new operations.NewConOp(id, this.readTsNew());
                return new operations.NewConOp(id, this.data[this.dataIdx++]);
            }
            case 8 /* JsonCrdtPatchOpcodeOverlay.new_val */: {
                return new operations.NewValOp(id);
            }
            case 16 /* JsonCrdtPatchOpcodeOverlay.new_obj */: {
                return new operations.NewObjOp(id);
            }
            case 24 /* JsonCrdtPatchOpcodeOverlay.new_vec */: {
                return new operations.NewVecOp(id);
            }
            case 32 /* JsonCrdtPatchOpcodeOverlay.new_str */: {
                return new operations.NewStrOp(id);
            }
            case 40 /* JsonCrdtPatchOpcodeOverlay.new_bin */: {
                return new operations.NewBinOp(id);
            }
            case 48 /* JsonCrdtPatchOpcodeOverlay.new_arr */: {
                return new operations.NewArrOp(id);
            }
            case 72 /* JsonCrdtPatchOpcodeOverlay.ins_val */: {
                return new operations.InsValOp(id, this.readTsOld(), this.readTsNew());
            }
            case 80 /* JsonCrdtPatchOpcodeOverlay.ins_obj */: {
                const length = extra || uint[this.uintIdx++];
                const obj = this.readTsOld();
                const opData = [];
                for (let i = 0; i < length; i++)
                    opData.push([this.data[this.dataIdx++], this.readTsNew()]);
                return new operations.InsObjOp(id, obj, opData);
            }
            case 88 /* JsonCrdtPatchOpcodeOverlay.ins_vec */: {
                const length = extra || uint[this.uintIdx++];
                const obj = this.readTsOld();
                const opData = [];
                for (let i = 0; i < length; i++)
                    opData.push([uint[this.uintIdx++], this.readTsNew()]);
                return new operations.InsVecOp(id, obj, opData);
            }
            case 96 /* JsonCrdtPatchOpcodeOverlay.ins_str */: {
                return new operations.InsStrOp(id, this.readTsOld(), this.readTsOld(), this.data[this.dataIdx++]);
            }
            case 104 /* JsonCrdtPatchOpcodeOverlay.ins_bin */: {
                return new operations.InsBinOp(id, this.readTsOld(), this.readTsOld(), this.data[this.dataIdx++]);
            }
            case 112 /* JsonCrdtPatchOpcodeOverlay.ins_arr */: {
                const length = extra || uint[this.uintIdx++];
                const obj = this.readTsOld();
                const ref = this.readTsOld();
                const vals = [];
                for (let i = 0; i < length; i++)
                    vals.push(this.readTsNew());
                return new operations.InsArrOp(id, obj, ref, vals);
            }
            case 120 /* JsonCrdtPatchOpcodeOverlay.upd_arr */: {
                return new operations.UpdArrOp(id, this.readTsOld(), this.readTsOld(), this.readTsNew());
            }
            case 128 /* JsonCrdtPatchOpcodeOverlay.del */: {
                const length = extra || uint[this.uintIdx++];
                const obj = this.readTsOld();
                const what = [];
                for (let i = 0; i < length; i++) {
                    const { sid, time } = this.readTsOld();
                    what.push((0, clock_1.tss)(sid, time, uint[this.uintIdx++]));
                }
                return new operations.DelOp(id, obj, what);
            }
            case 136 /* JsonCrdtPatchOpcodeOverlay.nop */: {
                return new operations.NopOp(id, extra || uint[this.uintIdx++]);
            }
            default: {
                throw new Error('UNKNOWN_OP');
            }
        }
    }
    readId() {
        return (0, clock_1.ts)(this.sidTable[this.s_new[this.s_newIdx++]], this.t_id[this.t_idIdx++]);
    }
    readTsNew() {
        return (0, clock_1.ts)(this.sidTable[this.s_new[this.s_newIdx++]], this.t_val[this.t_valIdx++]);
    }
    readTsOld() {
        return (0, clock_1.ts)(this.sidTable[this.s_old[this.s_oldIdx++]], this.t_obj[this.t_objIdx++]);
    }
}
exports.BatchColumnDecoder = BatchColumnDecoder;
